import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./fontend.css";
import "./App.css";
import "./pages/css/post-22.css";
import "./pages/css/post-22.css";
import "./pages/css/post-46.css";
import "./pages/css/post-52.css";
import "./pages/css/post-71.css";
import "./pages/css/post-136.css";
import "./pages/css/post-163.css";
import "./pages/css/post-7626.css";
import "./pages/css/post-9595.css";
import "./pages/css/post-9598.css";
import "./pages/css/frontend.min.css";
import "./pages/css/frontend1.min.css";
import "./pages/css/default-vars.min.css";
import "./pages/css/gutenberg-wp-frontend.min.css";
import "./pages/forminator/style-20.css";
import "./pages/style.css";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import RouterIndex from "./RouterIndex";
import Lottie from "lottie-react";
import loaderAnimation from "./loader.json";
import DemosPreviewButtons from "./pages/DemosPreviewButtons";
function App() {
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    // Simulate a delay (e.g., fetching data)
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust time as needed
  }, []);
  return (
    <div>
    {loading ? (
      <div className="loader"> <Lottie animationData={loaderAnimation} loop={true} style={{ width: 250, height: 250 }} /></div> // Replace with an actual loader/spinner
    ) : (
      <div className="home page-template-default page page-id-7626 wp-embed-responsive theme-multibank woocommerce-no-js cmsmasters-content-layout-fullwidth elementor-default elementor-kit-22 elementor-page elementor-page-7626">
        <DemosPreviewButtons/>
      <Header />
      <main className="cmsmasters-main site-main">
        <div className="cmsmasters-main__outer">
          <div className="cmsmasters-main__inner">
            <div className="cmsmasters-content-wrap">
              <div className="cmsmasters-content">
                <BrowserRouter>
                  <RouterIndex />
                </BrowserRouter>,
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
    )}
  </div>
  
  );
}

export default App;
